module.exports = "https://portperrypedals.ca/_res/img/simplicity.a1abb3a.png";